module.exports = __webpack_public_path__ + "media/icons/menu-bar-63550b29.svg";